//
//
//
//
//
//

export default {
  name: 'app',
  mounted () {
    // this.$http.get('/api/bank/quota/getListByProductsCode?productCode=' + this.productCode).then(response => {
    //   let banksFromServer = response.data
    //   if (banksFromServer.result === 'true' && banksFromServer.data.length > 0) {
    //     const banks = []
    //     banksFromServer.data.forEach((ele) => {
    //       banks.push({name: ele.bankName, value: ele.bankCode})
    //     })
    //     console.log(banks, banksFromServer.data)
    //     this.$store.commit('UPDATE_BANKSFROMSERVER', banks)
    //     this.$store.commit('UPDATE_RAWBANKSFROMSERVER', banksFromServer.data)
    //   }
    // })
  }
}



// WEBPACK FOOTER //
// ./src/App.vue